import { render, staticRenderFns } from "./admin-register.vue?vue&type=template&id=485d55ef&scoped=true&"
import script from "./admin-register.vue?vue&type=script&lang=js&"
export * from "./admin-register.vue?vue&type=script&lang=js&"
import style0 from "./admin-register.vue?vue&type=style&index=0&id=485d55ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d55ef",
  null
  
)

export default component.exports